module.exports = __webpack_public_path__ + "img/search-24px.d378117f.svg";